"use client";

import { useState, useEffect } from "react";

/**
 * モバイル横向き警告モーダルコンポーネント
 * モバイルデバイスで横向きになった場合に縦向きを促すモーダルを表示
 */
export default function LandscapeWarningModal() {
  const [isLandscape, setIsLandscape] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // タッチデバイスかどうか（PC除外用）
      const isTouchDevice =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        (window.matchMedia &&
          window.matchMedia("(pointer: coarse)").matches);

      // 画面の短い辺が768px以下
      const minDimension = Math.min(window.innerWidth, window.innerHeight);
      const isSmallScreen = minDimension <= 768;

      // タッチデバイスかつ小さい画面の場合のみモバイルと判定
      const isMobile = isTouchDevice && isSmallScreen;

      // 横向きかどうか
      const isLandscapeMode = window.innerWidth > window.innerHeight;

      setIsLandscape(isMobile && isLandscapeMode);
    };

    // 初回チェック
    checkOrientation();

    // リサイズと向き変更を監視
    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);

  if (!isLandscape) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px 40px",
          minWidth: "300px",
          maxWidth: "90%",
          borderRadius: "0",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
          textAlign: "center",
        }}
      >
        {/* アイコン */}
        <div
          style={{
            fontSize: "60px",
            marginBottom: "20px",
          }}
        >
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#e74c3c"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              animation: "rotate90 1.5s ease-in-out infinite",
            }}
          >
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <line x1="12" y1="18" x2="12" y2="18" />
          </svg>
        </div>

        {/* メッセージ */}
        <p
          style={{
            fontSize: "20px",
            color: "#e74c3c",
            fontWeight: "bold",
            lineHeight: "1.6",
            margin: "0",
          }}
        >
          画面を縦向きにしてください
        </p>
      </div>
    </div>
  );
}
